import { AnyAction } from 'redux';

import { splitOnLastUnderscore } from '@futrli/shared-services';
import { REG_REJECTED_RESET_ERROR } from '@futrli/shared-services';

import { stringToErrorStore } from '../../core/service';
import { AuthErrorsState } from '../../core/types';

/**
 * Standard error reducer in order to manage all the errors in a common place.
 * This reducer manage `resetError` action too.
 * @param {AuthErrorsState} state
 * @param {AnyAction} action
 * @return {string} new state
 */
export const standardErrorReducer = (state: AuthErrorsState = {}, action: AnyAction): AuthErrorsState => {
  const { type } = action;

  if (REG_REJECTED_RESET_ERROR.test(type)) {

    const { payload = null } = action;
    const [actionName] = splitOnLastUnderscore(type);
    const error = payload ? stringToErrorStore(payload) : null;

    return {
      ...state,
      [actionName]: error
    };
  }

  return state;
};
